import { useState } from "react";
import { Flag } from "react-feather";
import { ReportPageDialog } from "./ReportPageDialog";

interface CustomJoinPageStripProps {
  brandName: string;
  username: string;
}

/**
 * The one piece of the public join route a brand cannot style: a single quiet
 * line *below* its page. It carries the brand's name as Reveshare knows it
 * (the impersonation check) and the way to report the page. Neutral tokens,
 * no brand colours, never overlaps the page above it.
 */
export function CustomJoinPageStrip({ brandName, username }: CustomJoinPageStripProps) {
  const [reporting, setReporting] = useState(false);

  return (
    <>
      <div className="border-t border-border bg-background px-4 py-2 text-center text-xs text-muted-foreground">
        <span className="font-medium text-foreground/80">{brandName}</span>
        <span aria-hidden="true"> · </span>
        <span>Affiliate program on Reveshare</span>
        <span aria-hidden="true"> · </span>
        <button
          type="button"
          onClick={() => setReporting(true)}
          className="inline-flex items-center gap-1 underline-offset-2 hover:text-foreground hover:underline"
        >
          <Flag size={11} aria-hidden="true" />
          Report this page
        </button>
      </div>
      <ReportPageDialog
        open={reporting}
        onClose={() => setReporting(false)}
        username={username}
        brandName={brandName}
      />
    </>
  );
}
